/* eslint-disable @typescript-eslint/no-floating-promises */
import {useEffect, useState} from 'react';
import * as store from '@/store';
import sdk from '@/sdk';

import toast, {ToastType} from '@/components/Toast';
import {useIntl} from 'react-intl';
import styles from './index.module.scss';
import ConfirmDialog from '@/components/ConfirmDialog';
import Text, {TextType, TextColor} from '@/components/Text';


interface ConvertToDocDocumentProps {
    convertToDoc?: {docGuid: string};
    curRepository?: Repository;
}


function ConvertToDocDocument(props: ConvertToDocDocumentProps) {
    const intl = useIntl();
    const {
        convertToDoc, curRepository,
    } = props;
    const [open, setOpen] = useState(false);
    const docGuid = convertToDoc ? convertToDoc.docGuid : '';

    useEffect(() => {
        if (docGuid) {
            setOpen(true);
        }
    }, [docGuid, convertToDoc]);

    async function handleConfirm() {
        try {
            const ksServer = await sdk.getKsServer(curRepository);
            const result = await ksServer.convertToDoc(curRepository?.repositoryGuid || '', docGuid);
            if (result) {
                toast({
                    content: result,
                    type: ToastType.Error,
                });
                return;
            }
            location.reload();
        } catch (error) {
            const toastText = navigator.onLine ? 'convertErrorText' : 'notworkErrorText';
            toast({
                content: intl.formatMessage({id: toastText}),
                type: ToastType.Error,
            });
        }
    }

    function handleCancel() {
        setOpen(false);
    }

    return (
        <ConfirmDialog
            visible={open}
            headline={
                <div className={styles.convertToDocHead}>
                    {intl.formatMessage({id: 'indexMenuConvertToDoc'})}
                </div>}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            showCloseX
            width={388}
            className={styles.convertToDocBtn}
        >
            <div className={styles.convertContent}>
                <Text>变更为文档后，子页面将不再继承知识本成员权限。</Text>
            </div>
        </ConfirmDialog>
    );
}

const ConvertToDocDocumentImpl = store.connect([
    store.KEYS.CONVERTTODOC_DOCUMENT,
    store.KEYS.CUR_REPOSITORY,
])(ConvertToDocDocument);

export default ConvertToDocDocumentImpl;
